import cx from 'classnames';
import { formatThousands } from 'mk/bazaar/common/formatters';
import { ProductQuality } from 'mk2/apps/bazaar/schemas';
import useEventCallback from 'mk2/hooks/useEventCallback';
import React from 'react';
import styles from './QualityCheckbox.mscss';

export interface OwnProps {
    className?: string;
    quality: ProductQuality;
    checked: boolean;
    count: number;
    countHidden?: boolean;
    label: string;

    onChange(key: ProductQuality, checked: boolean);
}

type Props = OwnProps;

const QualityCheckbox: React.FunctionComponent<Props> = ({ className, quality, checked, count, countHidden, label, onChange }) => {
    const onChangeCallback = useEventCallback(
        (event: React.FormEvent<HTMLInputElement>) => {
            onChange(quality, event.currentTarget.checked);
        },
        [onChange, quality],
    );

    return (
        <label
            className={cx(
                styles.QualityCheckbox,
                className,
                styles[`QualityCheckbox--${quality}`],
                !checked && styles['QualityCheckbox--inactive'],
            )}
        >
            <input
                type="checkbox"
                checked={checked}
                onChange={onChangeCallback}
                className={styles.QualityCheckbox__input}
            />
            <span className={styles.QualityCheckbox__text}>
                {label}
                {!countHidden && (
                    <span
                        className={cx(
                            styles.QualityCheckbox__count,
                            styles[`QualityCheckbox__count--${quality}`],
                            !checked && styles['QualityCheckbox__count--inactive'],
                        )}
                    >
                        &nbsp;
                        ({formatThousands(count)})
                    </span>
                )}
            </span>
        </label>
    );
};

QualityCheckbox.displayName = 'QualityCheckbox';

export default React.memo<Props>(QualityCheckbox);
